import { api } from "./api";

/**
 * A17 — Booking possibility check.
 *
 * Calls the public helper endpoint `POST /api/booking-possibility` with
 * a proposed delivery window and postal code. Returns
 * `{ possible, reason_code?, cutoff_at?, delay_days? }`.
 */
export const bookingPossibilityService = {
  async check({ from_date, until_date, postal_code }) {
    const { data } = await api.post("/booking-possibility", {
      from_date,
      until_date,
      postal_code,
    });
    return data;
  },
};
